jQuery(document).ready(function ($) {
  let matterportModals = $('.reveal').has('.virtual-tour__iframe');

  matterportModals.on('open.zf.reveal', function (event) {
    let modal = $(this);
    let iframe = modal.find('.virtual-tour__iframe');

    console.log('Matterport modal detected:', modal.attr('id'));

    if (iframe.length) {
      let src = iframe.attr('src');
      console.log('Refreshing Matterport iframe - Original src:', src);

      iframe.attr('src', '');
      console.log('Iframe src cleared');

      setTimeout(() => {
        iframe.attr('src', src);
        console.log('Iframe src restored:', src);
      }, 100);

      setTimeout(() => {
        $(window).trigger('resize');
        console.log('Window resize event triggered for Matterport');
      }, 100);
    }
  });
});
